<div class="trip-details" *ngIf="tripDetails!==null">
  <div class="p-g panel-div">
    <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad">
      <div class="p-g">
        <div class="p-g-12">
          <span class="info-label" translate>label_status</span>: {{tripDetails.quotationStatus }}
        </div>
        <div class="p-g-12">
          <div>{{ tripDetails.bookingType }}
            <span translate>label_booking</span>
          </div>
        </div>
      </div>
    </div>
    <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad">
      <div class="p-g">
        <div class="p-g-12">
          <span class="info-label" translate>label_trip_id</span> {{tripDetails.tripId }}
        </div>
        <div class="p-g-12">
          <span class="info-label" translate>label_service_id</span> {{tripDetails.serviceType }}
        </div>
      </div>
    </div>

    <div [hidden]="!(tripDetails.roomNum)" class="p-g-12">
      <span class="info-label" translate>label_room_num</span> {{tripDetails.roomNum}}
    </div>
    <div class="p-g-12">
      <span class="info-label" translate>label_pickup_date_time</span> {{tripDetails.pickupDateTime|datetimeformat}}
    </div>

    <div class="p-g-12">
      <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad" *ngIf="tripDetails.vehicleType!==null">
        <span class="info-label" translate>label_vehicle_type</span> {{tripDetails.vehicleType }}
      </div>
      <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad" *ngIf="tripDetails.passangerCount!==null">
        <span class="info-label" translate>label_no_of_passenger</span> {{tripDetails.passangerCount }}
      </div>
    </div>

    <div class="p-g-12" *ngIf="tripDetails.note!=null && tripDetails.note!=undefined">
      <button type="button" (click)="showDialog()" pButton icon="fa fa-external-link-square" label="View Note"></button>
    </div>

    <div class="p-g-12">
      <span class="pickup-circle">&#9673;</span> {{tripDetails.pickupLocationName }}
    </div>
    <div class="p-g-12">
      <span class="drop-circle">&#9673;</span> {{tripDetails.dropLocationName }}
    </div>

    <div class="p-g-12" *ngIf="tripDetails.packageName!=undefined && tripDetails.packageName!=null">
      <div class="p-g-12 p-md-12 p-lg-12 p-g-nopad">
        <span class="info-label" translate>label_package</span>
        <span *ngIf="tripDetails.distance!=null && tripDetails.distance >0">{{tripDetails.distance/1000 }}</span>
        <span *ngIf="tripDetails.distance!=null && tripDetails.distance>0" translate>label_km</span>
        <span *ngIf="hour!=null && hour>0">{{hour}}</span>
        <span *ngIf="hour!=null && hour>0" translate>label_hr</span>
        <span *ngIf="mins!=null && mins>0">{{mins}}</span>
        <span *ngIf="mins!=null && mins>0" translate>label_mins</span>
      </div>
    </div>

    <div class="p-g-12">
      <div *ngIf="tripDetails.totalAmount" class="p-g-12 p-md-12 p-lg-12 p-g-nopad">
        <span class="info-label"><span translate>label_trip_amount</span>: </span>
        <span>{{tripDetails.totalAmount}}</span>
      </div>
    </div>


    <div class="p-g-12" *ngIf="tripDetails.uploadedQuotation!=undefined && tripDetails.uploadedQuotation!=null">
      <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad">
        <span class="info-label" translate>label_previous_quotation</span>
      </div>

      <div class="p-g-12">
        <div class="p-g-7 p-md-7 p-lg-7 p-g-nopad info-label" translate>
          label_description
        </div>

        <div class="p-g-2 p-md-2 p-lg-2 p-g-nopad info-label" translate>
          label_amount
        </div>
        <div class="p-g-3 p-md-3 p-lg-3 p-g-nopad info-label" translate>
          label_date_time_list
        </div>
      </div>
      <div class="p-g-12" *ngFor="let quoteInfo of tripDetails.uploadedQuotation;let i = index">
        <div class="p-g-2 p-md-2 p-lg-2 p-g-nopad">
          <a class="view-route-link" translate [href]="quotationBaseURL + quoteInfo.quotationFileId" download>
            <i class="fa fa-download" aria-hidden="true" title="Download"></i>
          </a>
        </div>
        <div class="p-g-5 p-md-5 p-lg-5 p-g-nopad" *ngIf="quoteInfo.description!==null">
          {{quoteInfo.description}}
        </div>
        <div class="p-g-5 p-md-5 p-lg-5 p-g-nopad" *ngIf="quoteInfo.description==null">
          View Quote {{i+1}}
        </div>
        <div class="p-g-2 p-md-2 p-lg-2 p-g-nopad">
          {{quoteInfo.quotationAmount}}
        </div>
        <div class="p-g-3 p-md-3 p-lg-3 p-g-nopad">
          {{quoteInfo.createdAt|datetimeformat}}
        </div>

      </div>
    </div>

    <div class="p-g-12" *ngIf="tripDetails.fareEstimate!=undefined">
      <div class="info-label" translate>label_qoutation_fare_estimate</div>
      <div>{{tripDetails.fareEstimate}}</div>
    </div>

    <div class="p-g-12" *ngIf="tripDetails.rejectionReason!==null && tripDetails.rejectionReason!= undefined">
      <div class="info-label" translate>label_quotation_reason_for_cancel</div>
    </div>
    <div class="p-g-12" *ngIf="tripDetails.rejectionReason!==null && tripDetails.rejectionReason!= undefined">
      <div>{{tripDetails.rejectionReason}}</div>
    </div>

    <div class="p-g-12" *ngIf="tripDetails.cancellationReason!==null && tripDetails.cancellationReason!= undefined">
      <div class="info-label" translate>label_cancellation_reason</div>: {{tripDetails.cancellationReason}}
    </div>

    <div class="p-g-12" *ngIf="tripDetails.statusBtn">
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.cancelTripBtnDisabled" [label]="cancelTrip" icon="fa fa-times"
        (click)="onCancelTrip()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.endTripBtnDisabled" [label]="endTrip" icon="fa fa-stop-circle"
        (click)="onEndTrip()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.startTripBtnDisabled" [label]="startTrip" icon="fa fa-play"
        (click)="onStartTrip()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.securityCheckBtnDisabled" [label]="securityCheck"
        icon="fa fa-check" (click)="onSecurityCheck()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.deliveryCheckBtnDisabled" [label]="deliveryCheck"
        icon="fa fa-check" (click)="onDeliveryCheck()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.carReturnCheckBtnDisabled" [label]="carReturnCheck"
        icon="fa fa-check" (click)="onCarReturnCheck()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.returnSecurityCheckBtnDisabled" [label]="returnSecurityCheck"
        icon="fa fa-check" (click)="onReturnSecurityCheck()"></button>
      <button class="one-line-block" pButton type="button" *ngIf="!tripDetails.extendTripBtnDisabled" [label]="extendTrip" icon="fa fa-check"
        (click)="onExtendTrip()"></button>
    </div>
    <div class="p-g-12">
      <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad" *ngIf="tripDetails.quotationStatus==='NEW_REQUEST' || tripDetails.quotationStatus==='QUOTE_REJECTED'">
        <button class="one-line-block" pButton type="button" [label]="uploadQuote" icon="fa fa-upload" ></button>

      </div>
      <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad" *ngIf="tripDetails.quotationStatus==='QUOTE_SENT' || tripDetails.quotationStatus==='RENEGOTIATED'">
        <button class="one-line-block" pButton type="button" [label]="resendQuote" icon="fa fa-check" ></button>
      </div>
      <div class="p-g-6 p-md-6 p-lg-6 p-g-nopad" *ngIf="tripDetails.quotationStatus==='NEW_REQUEST' ||
       tripDetails.quotationStatus==='QUOTE_REJECTED' || tripDetails.quotationStatus==='QUOTE_SENT'
       || tripDetails.quotationStatus==='RENEGOTIATED'">
        <button class="one-line-block" pButton type="button" [label]="cancelBooking" icon="fa fa-check" (click)="cancelSalesBooking()"></button>
      </div>
    </div>
  </div>

  <p-dialog header="Note" [(visible)]="display" modal="modal" width="300" [responsive]="true">
    <p *ngIf="tripDetails.note!==null">{{tripDetails.note}}</p>
  </p-dialog>


  <p-dialog header="OTP Verification" [(visible)]="OTP" modal="modal" width="300" [responsive]="true" [closable]="false">
    <app-otp [inputLabel]="enterOtp" (onOtpPopClose)="closeAllPopup($event)" (onOtpPopSave)="onOtpPopSave($event)" (onOtpProcess)="onStartTripProcess($event)"></app-otp>
  </p-dialog>

  <p-dialog header="OTP Verification" [(visible)]="securityCheckOTP" modal="modal" width="300" [responsive]="true" [closable]="false">
    <app-otp [inputLabel]="enterOtp" (onOtpPopClose)="closeAllPopup($event)" (onOtpPopSave)="onOtpPopSave($event)" (onOtpProcess)="onSecurityCheckProcess($event)"></app-otp>
  </p-dialog>

  <p-dialog header="Delivery Check" [(visible)]="deliveryCheckStartKM" modal="modal" width="300" [responsive]="true" [closable]="false">
    <app-otp [inputLabel]="currentKM" (onOtpPopClose)="closeAllPopup($event)" (onOtpPopSave)="onOtpPopSave($event)" (onOtpProcess)="onDeliveryCheckProcess($event)"></app-otp>
  </p-dialog>

  <p-dialog header="Car Return Check" [(visible)]="carReturnCheckEndTrip" modal="modal" width="300" [responsive]="true" [closable]="false">
    <app-otp [inputRequired]="false" (onOtpPopClose)="closeAllPopup()" (onOtpPopSave)="onOtpPopSave($event)" (onOtpProcess)="onCarReturnCheckProcess($event)"></app-otp>
  </p-dialog>

  <p-dialog header="Return Security Check" [(visible)]="returnSecurityCheckEndKM" modal="modal" width="300" [responsive]="true"
    [closable]="false">
    <app-otp [inputLabel]="currentKM" (onOtpPopClose)="closeAllPopup()" (onOtpPopSave)="onOtpPopSave($event)" (onOtpProcess)="onReturnSecurityCheckProcess($event)"></app-otp>
  </p-dialog>







  <!--Cancel trip dailog start-->
  <p-dialog header="Cancel Trip" [(visible)]="displayCancelTrip" modal="modal" width="300" [responsive]="true" [closable]="false">
    <div class="p-g-12 p-lg-12 p-md-12">
      <div class="form-field p-g-12 p-md-12 p-lg-12">
        <div class="form-label">
          <label for="quotationamount" translate>label_cancel_reason</label>
        </div>
        <div class="form-control">
          <input [(ngModel)]="cancelReasonText" type="text" pInputText />
        </div>
      </div>

      <div class="form-buttons p-g-12">
        <button pButton type="button" label="Cancel Trip" icon="fa fa-reply" (click)="doCancel()"></button>
        <button class="negative-button" pButton type="button" icon="fa fa-close" label="Cancel" (click)="cancel()"></button>
      </div>
    </div>
  </p-dialog>
  <!--Cancel trip dailog end-->
</div>
<div class="trip-details" *ngIf="tripDetails == null">
  <div class="p-g-12">
    <div class="info-label" translate>booking_details_result</div>
  </div>
</div>

<!-- <p-confirmDialog [header]="extendTripHeader" icon="fa fa-question-circle" [cdkTrapFocus]="appConfirmDialogFocusValue" [appConfirmDialogFocus]="appConfirmDialogFocusValue"></p-confirmDialog> -->
